import i18n from "@/i18n";
import { IMenuRoute } from "@/models/routes";
import store from "@/store";

export default [
  {
    label: "_.account",
    children: [
      {
        label: "_.overview",
        to: { name: "admin__account" }
      }
    ]
  }
] as IMenuRoute[];

export const AccountRoutes: () => IMenuRoute[] = () => [
  {
    label: i18n.t("_.profile"),
    to: {
      name: "adminAccountProfile"
    }
  },
  {
    label: i18n.t("_.security"),
    to: {
      name: "adminAccountSecurity"
    }
  },
  {
    if: () => store.getters["user/isUpmindClient"],
    label: i18n.t("_.my_upmind_account"),
    to: {
      name: "admin__upmindAccount"
    },
    children: [
      {
        label: i18n.t("_.invoices"),
        to: {
          name: "admin__upmindInvoices"
        }
      },
      {
        label: i18n.t("_.tickets"),
        to: {
          name: "admin__upmindTickets"
        }
      }
    ]
  },
  {
    label: i18n.t("_.email_history"),
    to: {
      name: "adminAccountEmailHistory"
    }
  },
  {
    label: i18n.t("_.activity_log"),
    to: {
      name: "adminAccountActivityLog"
    }
  }
];

export const UpmindInvoicesRoutes: () => IMenuRoute[] = () => [
  {
    label: i18n.t("_.all"),
    to: {
      name: "admin__allUpmindInvoices"
    }
  },
  {
    label: i18n.t("_.paid"),
    to: {
      name: "admin__paidUpmindInvoices"
    }
  },
  {
    label: i18n.t("_.unpaid"),
    to: {
      name: "admin__unpaidUpmindInvoices"
    }
  },
  {
    label: i18n.t("_.credited"),
    to: {
      name: "admin__creditedUpmindInvoices"
    }
  }
];
